// Projeto atual

import styled from 'styled-components';
import LoginBg from '../../assets/images/login-bg.jpeg';

export const Background = styled.div`
    width: 100vw;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(${LoginBg});
    background-size: cover;
    background-repeat: no-repeat;
`;

export const LoginSpace = styled.div`
    background-color: var(--login-bg-color);
    border-radius: 20px;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    padding: 40px 32px 32px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 350px;
    max-width: 400px;
    width: 100%;
    gap: 24px;

    @media (max-width: 500px) {
        min-width: 90vw;
        padding: 24px 8px;
    }
`;

export const Image = styled.img`
    height: 75px;
    display: flex;
    justify-content: center;
    align-self: center;
`;

export const Title = styled.h1`
    color: var(--primary-font-color);
    font-size: 2.5em;
    font-weight: 700;
    text-align: center;
    margin-bottom: 10px;
    letter-spacing: 1px;
`;

export const Form = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;
`;

export const Button = styled.button`
    border: none;
    background-color: var(--main-color);
    color: var(--button-text-color);
    text-transform: uppercase;
    cursor: pointer;
    padding: 14px 0;
    border-radius: 8px;
    font-weight: 800;
    font-size: 1.1em;
    width: 100%;
    transition:
        transform 0.3s,
        box-shadow 0.3s;

    &:hover {
        transform: scale(1.04);
        box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.25);
    }
`;

export const ForgotPassword = styled.div`
    color: var(--main-color);
    font-weight: 600;
    cursor: pointer;
    margin-top: 10px;
    text-align: center;
    border-bottom: 2px solid var(--main-color);
    transition:
        border 0.2s,
        color 0.2s;

    &:hover {
        color: var(--primary-font-color);
        border-bottom: 2px solid transparent;
        text-decoration: underline;
    }
`;

export const RecaptchaWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 10px 0 0 0;
`;
